// Sayfa bazlı SEO yönetimi (SPA içinde title / description / canonical / JSON-LD)
// Googlebot JavaScript çalıştırdığı için client tarafında ayarlanan bu etiketler indexlemeye girer.

const SITE_URL = 'https://qrezervasyon.com.tr';

const upsertMeta = (name, content) => {
    let el = document.querySelector(`meta[name="${name}"]`);
    if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', name);
        document.head.appendChild(el);
    }
    el.setAttribute('content', content);
};

const upsertProperty = (property, content) => {
    let el = document.querySelector(`meta[property="${property}"]`);
    if (!el) {
        el = document.createElement('meta');
        el.setAttribute('property', property);
        document.head.appendChild(el);
    }
    el.setAttribute('content', content);
};

const upsertCanonical = (href) => {
    let el = document.querySelector('link[rel="canonical"]');
    if (!el) {
        el = document.createElement('link');
        el.setAttribute('rel', 'canonical');
        document.head.appendChild(el);
    }
    el.setAttribute('href', href);
};

const upsertJsonLd = (id, data) => {
    let el = document.getElementById(id);
    if (!el) {
        el = document.createElement('script');
        el.type = 'application/ld+json';
        el.id = id;
        document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
};

/**
 * Sayfanın SEO etiketlerini günceller.
 * @param {{ title?: string, description?: string, canonicalPath?: string, jsonLd?: object, jsonLdId?: string }} options
 */
export const setPageSeo = ({ title, description, canonicalPath, jsonLd, jsonLdId }) => {
    try {
        if (title) {
            document.title = title;
            upsertProperty('og:title', title);
        }
        if (description) {
            upsertMeta('description', description);
            upsertProperty('og:description', description);
        }
        if (canonicalPath) {
            const url = SITE_URL + canonicalPath;
            upsertCanonical(url);
            upsertProperty('og:url', url);
        }
        if (jsonLd) {
            upsertJsonLd(jsonLdId || 'page-jsonld', jsonLd);
        }
    } catch (e) {
        // SEO etiketi hatası kullanıcı akışını asla bozmamalı
        console.error('SEO tag error:', e);
    }
};

export { SITE_URL };
